import axios from 'axios'
import request from '@/utils/request'

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
 export function fetch(url,params={}){
    return new Promise((resolve,reject) => {
      axios.get(url,{params:params,})
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  export function post(url,params = {}){
    return new Promise((resolve,reject) => {
      axios.post(url,params)
        .then(response => {
          resolve(response);
        },err => {
          reject(err)
  
        })
    })
  }
  
  /**
   * 封装patch请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  
  export function patch(url,data = {}){
    return new Promise((resolve,reject) => {
      axios.patch(url,data)
        .then(response => {
          resolve(response);
        },err => {
          reject(err)
        })
    })
  }
  
  /**
   * 封装put请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  
  export function put(url,data = {}){
    return new Promise((resolve,reject) => {
      axios.put(url,data)
        .then(response => {
          resolve(response);
        },err => {
          reject(err)
        })
    })
  }
  
  /**
   * 封装delete请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  
  export function Del(url,params = {}){
    return new Promise((resolve,reject) => {
      axios.delete(url,{data:params})
        .then(response => {
          resolve(response);
        },err => {
          reject(err)
        })
    })
  }
  
  /**
 * 文件流下载
 * @param method
 * @param url
 * @param data
 * @returns {Promise}
*/
export function fileDownload(method, url, params = {}) {
  return new Promise((resolve, reject) => {
    let axiosRequestParams = {
      method,
      url,
      responseType: 'arraybuffer', // 告诉axios请求的是二进制数据流
      data: params, // post
      params: params // get
    }
    let value = method.toLowerCase() == 'post' ? 'params' : 'data';
    delete axiosRequestParams[value];
    axios(axiosRequestParams).then(response => {
      resolve(response);
    }, err => {
      reject(err);
    });
  });
}